import { render, staticRenderFns } from "./QuizSourceCard.vue?vue&type=template&id=708e6188&scoped=true"
import script from "./QuizSourceCard.vue?vue&type=script&lang=js"
export * from "./QuizSourceCard.vue?vue&type=script&lang=js"
import style0 from "./QuizSourceCard.vue?vue&type=style&index=0&id=708e6188&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e6188",
  null
  
)

export default component.exports